{
  "name": "enrollhere-payments",
  "version": "0.20.0-c024da4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "vitest",
    "test:ci": "vitest run --coverage",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint src/ --ext .ts,.html",
    "lint:fix": "eslint src/ --ext .ts,.html --fix",
    "format": "prettier --check \"src/**/*.{ts,html,scss}\"",
    "format:fix": "prettier --write \"src/**/*.{ts,html,scss}\"",
    "replace-timestamp": "node ./replace.build.js",
    "login": "gcloud auth login && npx google-artifactregistry-auth",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org enrollhere --project enrollhere-payments ./dist && sentry-cli sourcemaps upload --org enrollhere --project enrollhere-payments ./dist"
  },
  "private": true,
  "workspaces": [
    "src/app/common"
  ],
  "dependencies": {
    "@angular/animations": "22.2.1",
    "@angular/cdk": "22.1.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/platform-browser-dynamic": "22.2.1",
    "@angular/platform-server": "22.2.1",
    "@angular/router": "22.2.1",
    "@angular/service-worker": "22.2.1",
    "@angular/ssr": "22.2.2",
    "@enrollhere/classes": "1.0.440",
    "@floating-ui/dom": "^1.8.0",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/pro-regular-svg-icons": "^7.3.1",
    "@ngrx/effects": "22.0.0-beta.0",
    "@ngrx/store": "22.0.0-beta.0",
    "@sentry/angular": "^10.68.0",
    "@sentry/cli": "^3.6.0",
    "@stripe/stripe-js": "^9.9.0",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/typography": "^0.5.20",
    "@tanstack/angular-query-experimental": "^5.101.4",
    "ag-grid-angular": "^35.2.1",
    "ag-grid-enterprise": "^35.2.1",
    "echarts": "^6.1.0",
    "express": "^5.2.1",
    "firebase": "^12.16.0",
    "libphonenumber-js": "^1.13.9",
    "loglevel": "^1.9.2",
    "loglevel-plugin-prefix": "^0.8.4",
    "ngx-cookie-service": "^22.0.0",
    "ngx-echarts": "^22.0.0",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-toastr": "20.0.5",
    "posthog-js": "^1.407.2",
    "replace-in-file": "^8.4.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.1",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.8.0",
    "@analogjs/vitest-angular": "2.8.0",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.1",
    "@eslint/js": "^10.0.1",
    "@ngrx/eslint-plugin": "22.0.0-rc.0",
    "@types/express": "^5.0.6",
    "@types/node": "^26.1.1",
    "@typescript-eslint/eslint-plugin": "^8.65.0",
    "@typescript-eslint/parser": "^8.65.0",
    "@vitest/coverage-v8": "4.1.11",
    "autoprefixer": "^10.5.4",
    "daisyui": "^5.7.4",
    "eslint": "~10.8.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "jsdom": "^30.0.0",
    "orval": "^8.30.0",
    "postcss": "^8.5.23",
    "prettier": "^3.9.6",
    "prettier-eslint": "^17.1.1",
    "sass": "^1.101.0",
    "tailwindcss": "^4.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.65.0",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "4.1.11"
  },
  "overrides": {
    "@analogjs/vite-plugin-angular": "$@analogjs/vite-plugin-angular",
    "@analogjs/vitest-angular": "$@analogjs/vitest-angular",
    "@angular/animations": "$@angular/animations",
    "@angular/build": "$@angular/build",
    "@angular/cdk": "$@angular/cdk",
    "@angular/cli": "$@angular/cli",
    "@angular/common": "$@angular/common",
    "@angular/compiler": "$@angular/compiler",
    "@angular/compiler-cli": "$@angular/compiler-cli",
    "@angular/core": "$@angular/core",
    "@angular/forms": "$@angular/forms",
    "@angular/platform-browser": "$@angular/platform-browser",
    "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic",
    "@angular/platform-server": "$@angular/platform-server",
    "@angular/router": "$@angular/router",
    "@angular/service-worker": "$@angular/service-worker",
    "@angular/ssr": "$@angular/ssr",
    "ngx-infinite-scroll": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "@ngrx/effects": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "@ngrx/signals": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "minimatch": ">=9.0.7",
    "yargs@<18.1.0": "18.1.0",
    "protobufjs": "8.8.0",
    "undici": "8.10.2",
    "dompurify": "3.4.16",
    "hono": "^4.13.7",
    "@hono/node-server": ">=2.1.1",
    "brace-expansion": "5.0.12",
    "glob": "11.1.0",
    "js-yaml": "4.3.2",
    "tar": "^7.5.22",
    "ngx-toastr": "20.0.5",
    "@angular-devkit/core": {
      "ajv": ">=8.19.0"
    },
    "fast-uri": "3.1.8",
    "nanoid@^3": "3.3.20",
    "enrollhere-common": {
      "dompurify": "3.4.16",
      "ngx-toastr": "20.0.5"
    },
    "jsdom": {
      "undici": "7.30.0"
    },
    "@ai-sdk/angular": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "vitest": "4.1.11",
    "@vitest/mocker": "4.1.11",
    "@vitest/coverage-v8": "4.1.11",
    "qs": "6.16.0",
    "body-parser": "2.3.0",
    "@tailwindcss/typography": {
      "postcss-selector-parser": "7.1.6"
    },
    "@grpc/grpc-js": "1.14.6",
    "@enrollhere/classes": "1.0.440"
  },
  "volta": {
    "node": "24.18.0"
  }
}
